<template>
    <div>
        <PageHeader title="Learning Center" heroImg="/images/learning-center-hero.webp"
            paragraph="Your resource for product training and understanding the complex standards behind protection to help you build product knowledge and make informed decisions with confidence." />
        <section id="training-101" class="py-8 md:py-12 px-0">
            <h2 class="text-2xl md:text-3xl text-dark-gray text-center uppercase">Product Training 101</h2>
            <div class="w-full learning-carousel">
                <VueSlickCarousel v-bind="settings">
                    <div v-for="(item, index) in carouselItems" :key="`${item.routeName}-${index}`" class="item px-2 md:px-4">
                        <router-link :to="{ name: item.routeName }" class="flex flex-col items-center text-center text-dark-gray">
                            <div class="img-wrap">
                                <img :src="item.image" :alt="item.title" />
                            </div>
                            <h3 class="text-center text-dark-gray mt-4">{{ item.title }}</h3>
                            <button class="block mt-2 btn btn-dark btn-pill learn-btn">Learn More</button>
                        </router-link>
                    </div>
                    <template #prevArrow>
                        <button class="slick-prev nav-arrow" type="button" aria-label="Previous">
                            <img src="/images/nav-arrow.svg" alt="Previous" />
                        </button>
                    </template>
                    <template #nextArrow>
                        <button class="slick-next nav-arrow" type="button" aria-label="Next">
                            <img src="/images/nav-arrow.svg" alt="Next" />
                        </button>
                    </template>
                </VueSlickCarousel>
            </div>
        </section>
        <section id="standards" class="py-8 md:py-12">
            <h2 class="text-2xl md:text-3xl text-dark-gray text-center uppercase">Understanding the Standards</h2>
            <div class="py-8 flex flex-col md:flex-row md:justify-center items-center md:items-stretch gap-6 md:gap-14 max-w-2xl mx-auto px-6">
                <router-link v-for="(standard, index) in standards" :key="index" :to="standard.href"
                    class="flex items-stretch text-dark-grey overflow-hidden max-w-[360px] w-full">
                    <div class="w-4 md:w-8 bg-red flex-shrink-0"></div>
                    <div class="p-6 md:p-8 bg-grey-100 flex-1">
                        <p class="uppercase text-sm mb-3">Standard Update</p>
                        <h3 class="text-3xl md:text-4xl font-bold text-dark-gray">{{ standard.title }}</h3>
                        <p class="mt-2 text-gray-600">{{ standard.desc }}</p>
                        <button class="btn btn-primary btn-pill mt-6">Learn More</button>
                    </div>
                </router-link>
            </div>
        </section>
    </div>
</template>
<script>
import PageHeader from '@/components/PageHeader.vue';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
    name: 'LearningNew',
    components: {
        PageHeader,
        VueSlickCarousel
    },
    data() {
        return {
            learningItems: [
                {
                    routeName: 'handprotectionexperts',
                    image: '/images/st-learning/hand-protection.webp',
                    title: 'HAND PROTECTION'
                },
                {
                    routeName: 'hivisapparelexperts',
                    image: '/images/st-learning/hi-vis.webp',
                    title: 'HI-VIS CLOTHING'
                },
                {
                    routeName: 'headprotectionexperts',
                    image: '/images/st-learning/head-protection.webp',
                    title: 'HEAD PROTECTION'
                },
                {
                    routeName: 'earprotectionexperts',
                    image: '/images/st-learning/hearing-protection.webp',
                    title: 'HEARING PROTECTION'
                },
                {
                    routeName: 'eyeprotectionexperts',
                    image: '/images/st-learning/eye-protection.webp',
                    title: 'EYE PROTECTION'
                }
            ],
            settings: {
                centerMode: true,
                centerPadding: '0px',
                focusOnSelect: true,
                dots: false,
                infinite: true,
                speed: 500,
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: true,
                autoplay: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: true,
                            centerPadding: '0px',
                            infinite: true,
                            dots: false
                        }
                    }
                ]
            },
            standards: [
                {
                    title: 'EN 388',
                    desc: 'For protective gloves against mechanical risks',
                    href: '/sales-tools/standards-en388'
                },
                {
                    title: 'ANSI 105',
                    desc: 'New classification levels and testing methods for cut resistance',
                    href: '/sales-tools/standards-ansi105'
                },
                {
                    title: 'ANSI 107',
                    desc: 'For hi-visibility safety apparel and accessories',
                    href: '/sales-tools/standards-ansi107'
                }
            ]
        };
    },
    computed: {
        carouselItems() {
            return [...this.learningItems, ...this.learningItems];
        }
    }
};
</script>

<style lang="scss" scoped>
.learning-carousel {
    position: relative;
    padding: 3rem 0 1rem;

    @media (min-width: 768px) {
        padding: 4.5rem 0 1rem;
    }

    ::v-deep .slick-slide {
        opacity: 0.35;
        transition: opacity 0.3s ease;

        >div {
            outline: none;
        }

    }

    ::v-deep .slick-slide:not(.slick-current) {

        h3,
        .learn-btn {
            opacity: 0 !important;
            pointer-events: none;
        }
    }

    ::v-deep .slick-slide.slick-current {
        opacity: 1;

        h3,
        .learn-btn {
            opacity: 1 !important;
        }
    }

    .img-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 140px;

        @media (min-width: 768px) {
            height: 200px;
        }

        img {
            max-height: 100%;
            max-width: 100%;
            width: auto;
            height: auto;
            object-fit: contain;
        }
    }

    ::v-deep h3 {
        color: var(--color-dark-grey);
        font-size: 1rem;
        font-weight: 700;
        letter-spacing: 0.05em;
        transition: opacity 0.3s ease;

        @media (min-width: 768px) {
            font-size: 1.125rem;
        }
    }

    ::v-deep .learn-btn {
        transition: opacity 0.3s ease;
    }

    ::v-deep .nav-arrow {
        position: absolute;
        top: -2.25rem;
        z-index: 2;
        width: 22px;
        height: 22px;
        padding: 0;
        background: transparent;
        border: none;
        cursor: pointer;

        @media (min-width: 768px) {
            top: -3.25rem;
            width: 26px;
            height: 26px;
        }

        img {
            width: 100%;
            height: 100%;
            display: block;
        }

        &::before {
            content: none;
        }
    }

    ::v-deep .slick-prev.nav-arrow {
        left: calc(50% - 28px);

        @media (min-width: 768px) {
            left: calc(50% - 34px);
        }

        img {
            transform: rotate(180deg);
        }
    }

    ::v-deep .slick-next.nav-arrow {
        right: calc(50% - 28px);

        @media (min-width: 768px) {
            right: calc(50% - 34px);
        }
    }

    ::v-deep .slick-disabled {
        opacity: 0.4;
        cursor: default;

    }

}
</style>
